import React from 'react';
import { TrendingUp, CheckCircle, Sparkles } from 'lucide-react';
import { transformationSection } from '../mock';

export const TransformationSection = () => {
  return (
    <section id="transformation" style={{
      background: 'linear-gradient(135deg, #2C3440 0%, #3A4149 50%, #434B54 100%)',
      padding: '8rem 1.5rem',
      color: 'white',
      position: 'relative'
    }}>
      {/* Mountain Background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.15
      }} />
      
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '5rem', maxWidth: '900px', margin: '0 auto 5rem' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.75rem',
            background: 'rgba(92, 112, 128, 0.6)',
            backdropFilter: 'blur(10px)',
            padding: '0.75rem 1.5rem',
            borderRadius: '3rem',
            fontSize: '0.875rem',
            fontWeight: 600,
            marginBottom: '2rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            fontFamily: "'Open Sans', sans-serif"
          }}>
            <Sparkles size={20} style={{ color: '#00BFFF' }} />
            The Transformation
          </div>
          
          <h2 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            lineHeight: 1.2,
            fontWeight: 700,
            marginBottom: '1.5rem',
            letterSpacing: '-0.01em',
            fontStyle: 'italic'
          }}>
            {transformationSection.heading}
          </h2>
          
          <h3 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
            lineHeight: 1.3,
            fontWeight: 600,
            color: '#7EC0D6'
          }}>
            {transformationSection.subheading}
          </h3>
        </div>

        {/* Benefits Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '2rem'
        }}>
          {transformationSection.benefits.map((benefit, index) => (
            <div key={index} style={{
              background: 'rgba(92, 112, 128, 0.4)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              borderRadius: '1rem',
              padding: '2rem',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(92, 112, 128, 0.5)';
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.borderColor = '#00BFFF';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(92, 112, 128, 0.4)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  background: 'rgba(0, 191, 255, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <CheckCircle size={24} color="#00BFFF" />
                </div>
                <div>
                  <h4 style={{
                    fontFamily: "'Open Sans', sans-serif",
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    marginBottom: '0.75rem',
                    color: '#FFFFFF'
                  }}>
                    {benefit.title}
                  </h4>
                  <p style={{
                    fontFamily: "'Open Sans', sans-serif",
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#E0E0E0'
                  }}>
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div style={{
          textAlign: 'center',
          marginTop: '5rem'
        }}>
          <div style={{
            background: 'rgba(92, 112, 128, 0.4)',
            backdropFilter: 'blur(10px)',
            border: '2px solid rgba(0, 191, 255, 0.3)',
            borderRadius: '1rem',
            padding: '3rem',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            <TrendingUp size={48} style={{ marginBottom: '1.5rem', color: '#00BFFF' }} />
            <h3 style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
              fontWeight: 700,
              marginBottom: '1rem',
              fontStyle: 'italic',
              color: '#FFFFFF'
            }}>
              This Is the Foundation Your Clients Have Been Missing
            </h3>
            <p style={{
              fontFamily: "'Open Sans', sans-serif",
              fontSize: '1.125rem',
              lineHeight: '1.7',
              color: '#E0E0E0'
            }}>
              When you address cellular health, you are not just treating symptoms—you are giving your clients the physical foundation they need for true, lasting recovery.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
